export const quickFactMixin = {
  data() {
    return {
      qfViewMore: false,
    };
  },
  methods: {
    quickFactViewMore() {
      this.qfViewMore = !this.qfViewMore;
    },
  },
};
